import { Icon } from '@vrplatform/icons';
import {
  EllipsisMenuCopyItem,
  EllipsisMenuDangerItem,
  EllipsisMenuDivider,
  EllipsisMenuItem,
} from '@vrplatform/components-legacy';
import { Box, Tooltip } from '@mantine/core';
import {
  EllipsisMenuAuditEffectsItem,
  HiddenFeatureIndicator,
} from '../../components';
import { useJournalEntriesModal } from '../../modals';

export const PayoutEllipsisMenuItems = ({
  payout,
  openDeleteModal,
  openEditModal,
}: {
  payout: {
    id: string;
    isReconciled: boolean;
    isPublished: boolean;
    lock?: {
      status?: string | null;
    } | null;
  };
  openDeleteModal: () => void;
  openEditModal: () => void;
}) => {
  const { open: openJournalEntriesModal } = useJournalEntriesModal();
  const lockStatus = payout.lock?.status;
  const isLocked = lockStatus === 'locked';
  const editDisabled = payout.isReconciled || payout.isPublished || isLocked;

  return (
    <>
      <Tooltip
        label={
          isLocked
            ? 'This payout is locked and cannot be edited.'
            : payout.isPublished
              ? 'This payout is related to a published owner statement. To edit the payout, please move all related owner statements back to draft'
              : 'This payout was matched and cannot be edited.'
        }
        multiline
        maw={400}
        position="left"
        disabled={!editDisabled}
      >
        <Box>
          <EllipsisMenuItem
            customIcon={<Icon icon="Edit3Icon" size={16} />}
            onClick={openEditModal}
            disabled={editDisabled}
          >
            Edit
          </EllipsisMenuItem>
        </Box>
      </Tooltip>

      <EllipsisMenuItem
        customIcon={<Icon icon="ListUnorderedIcon" size={16} />}
        onClick={() =>
          openJournalEntriesModal({
            transactionIds: [payout.id],
          })
        }
      >
        Journal Entries
      </EllipsisMenuItem>

      <EllipsisMenuDivider />

      <Tooltip
        label="Please unmatch the payout before deleting."
        disabled={!payout.isReconciled}
      >
        <Box>
          <EllipsisMenuDangerItem
            onClick={openDeleteModal}
            disabled={payout.isReconciled}
          >
            Delete
          </EllipsisMenuDangerItem>
        </Box>
      </Tooltip>

      <HiddenFeatureIndicator permission="vrp-admin">
        <EllipsisMenuAuditEffectsItem entityId={payout.id} />
        <EllipsisMenuCopyItem value={payout.id} />
      </HiddenFeatureIndicator>
    </>
  );
};
